import React, { Fragment, useCallback, useContext, useEffect, useMemo, useState } from 'react';

import Accordion from 'b2b-ui-components-lib/lib/components/accordion';
import RadioGroup from 'b2b-ui-components-lib/lib/components/radioGroup';
import Button from 'b2b-ui-components-lib/lib/components/button';
import DrawerModalComponent from 'home/view/manage-feasibility/components/organisms/drawer_modal';
import Datepicker from 'b2b-ui-components-lib/lib/components/datePicker';

import { SITE_READINESS_OPTIONS } from './constant';
import { getCurrentLead, getCurrentOrder } from 'tokenGeneration/lead.util';
import { getFromSessionStorage, getRange, isNull, setInSessionStorage, trackAnalytics } from 'common/utils/app.utils';
import moment from 'moment';
import { DATE_FORMATS } from 'featureLib/AppointmentEdl/constants';
import { ampmParser } from 'featureLib/AppointmentEdl/utils';
import { FILE_UPLOAD_PAGES, MULTI_SITE_MODULE_ID, SITE_READINESS_TABLE_EDITED, SUMMARY_AUTH_TOKEN } from 'home/view/manage-feasibility/constants';
import { fetchOrderDetails } from 'home/view/manage-feasibility/services';
import { isOrderConfirmationUrl } from 'dedicated/services/summary.service';
import { ORDER_TYPE } from 'common/constants/app.constants';
import { AppContext } from 'App';
import { SITE_READINESS_HEADER_ORDER, defaultDataPerPageOptions, defaultFilterOptions } from 'home/view/manage-feasibility/pages/DedicatedOrderSummary/constant';
import AddressProcess from 'home/view/manage-feasibility/components/organisms/addressProcessAOI/addressProcess';
import { TOAST_TYPE } from 'dedicated/components/plan-and-configuration/configure-plan-pricing-constant';

const SiteReadinessAccordion = ({
  accordionMeta,
  setAccordionMeta,
  cpmAccordionMeta,
  setCpmAccordionMeta,
  selectedOption,
  setSelectedOption,
  appointmentData,
  setAppointmentData,
  siteReadyByDate,
  setSiteReadyByDate,
  setShowWidget,
  isMultiSite = false,
  tableData,
  setTableData,
  setSelectedLineItem,
  slotBooked,
  setSlotBooked,
  customerNeedByDate,
  setCustomerNeedByDate,
  error,
  setError,
  isOrderConfirmation,
  circleData,
  cpmFormSchema
}) => {
  const { toast, setToast } = useContext(AppContext);

  const [showLoader, setShowLoader] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editFileMeta, setEditFileMeta] = useState({});
  const [totalSitesProcessed, setTotalSitesProcessed] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [filterValue, setFilterValue] = useState(defaultFilterOptions[0]);
  const [searchType, setSearchType] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [tableRows, setTableRows] = useState(SITE_READINESS_HEADER_ORDER);
  const [tableColumns, setTableColumns] = useState([]);
  const [dataPerPageValue, setDataPerPageValue] = useState(defaultDataPerPageOptions[0]);
  const [dataPerPageOptions, setDataPerPageOptions] = useState(defaultDataPerPageOptions);
  const [currentPage, setCurrentPage] = useState(1);
  const [isEdit, setIsEdit] = useState(false);
  const [filterApplied, setFiltersApplied] = useState(false);
  const [multiSortArr, setMultiSortArr] = useState([]);

  const order = getCurrentOrder?.();
  const defaultSiteReadyByDate = order?.lead?.connectivityLineItems?.[0]?.siteReadinessDate;
  const isSiteReadinessTableEdited = !!getFromSessionStorage(MULTI_SITE_MODULE_ID, SITE_READINESS_TABLE_EDITED);
  const isCircleEligible = useCallback(
    (circle) => circleData && Array.isArray(circleData.eligibleCircles) && (circleData.allCircles || circleData.eligibleCircles.includes(circle)),
    [circleData]
  );

  const handleCpmAccordionMeta = () => {
    if (cpmAccordionMeta.isValidated) {
      setCpmAccordionMeta((cpmAccordionMeta) => ({
        ...cpmAccordionMeta,
        isExpanded: false
      }));
    }
  };

  const handleRadioChange = (value) => {
    setSelectedOption(value);
    const data = history && history.location && history.location.state && history.location.state.orderData;
    trackAnalytics({
      eVar0: `b2b|${order?.serviceType}|buy|site readiness|edit details|site ${value.id === 'No' ? 'not' : ''} ready`,
      prop0: `b2b|${order?.lead?.customer?.segment}|${order?.serviceType}`,
      prop15: cpmFormSchema && cpmFormSchema.emailAddress && cpmFormSchema.emailAddress.value,
      prop17: cpmFormSchema && cpmFormSchema.name && cpmFormSchema.name.value,
      prop14: cpmFormSchema && cpmFormSchema.mobileNumber && cpmFormSchema.mobileNumber.value,
      prop35: order?.companyAddress?.officeName || '',
      prop39: order?.lead?.customer?.segment || '',
      prop40: order?.serviceType || '',
      prop37: order?.orderType || '',
      prop43: 1,
      prop9: order?.companyAddress?.pincode || '',
      prop36: order?.companyAddress?.officeName || '',
      prop20: order?.companyAddress?.addressLine1 || '',
      prop10: order?.orderId || '',
      prop29: order?.lead?.connectivityLineItems?.[0]?.selectedMedia?.[0]?.media || '',
      prop16: order?.companyAddress?.city || '',
      prop7: order?.siteIncharge?.firstName || '',
      prop8: order?.siteIncharge?.phoneNumber || '',
      prop9: order?.siteIncharge?.email || '',
      prop37: customerNeedByDate,
      prop14: value.id,
      prop11: cpmFormSchema && cpmFormSchema.name && cpmFormSchema.name.value,
      prop12: cpmFormSchema && cpmFormSchema.mobileNumber && cpmFormSchema.mobileNumber.value,
      prop13: cpmFormSchema && cpmFormSchema.emailAddress && cpmFormSchema.emailAddress.value
    });
    setError('');
    handleCpmAccordionMeta();
  };

  const handleOpenAppointment = (lineItem, reschedule) => {
    console.log(reschedule);
    setSelectedLineItem(lineItem);
    const lead = getCurrentLead();
    setTimeout(() => setShowWidget(true), 30);
    trackAnalytics({
      // eVar9: `b2b|${order?.serviceType}|buy|confirm installations|site readiness widget|schedule appointement`,
      eVar0: `b2b|${order?.serviceType}|buy|confirm installations|site readiness widget|${reschedule ? 'reschedule' : 'schedule'} appointement`,
      prop0: `b2b|${order?.lead?.customer?.segment}|${order?.serviceType}`,
      prop15: order?.customerEmail || '', //email address
      prop17: `${order?.lead?.customer?.authorizedSignatory?.firstName || ''} ${order?.lead?.customer?.authorizedSignatory?.lastName || ''}`, //full name
      prop14: order?.lead?.customer?.authorizedSignatory?.phoneNumber || '', //phone number
      prop35: order?.companyAddress?.officeName || '',
      prop39: order?.lead?.customer?.segment || '',
      prop40: order?.serviceType || '',
      prop37: order?.orderType || '',
      // prop41=<type of site>
      // Prop43=<no. of sites>
      // prop21=<feasibility request id>
      // Prop23=<link id>
      prop9: order?.companyAddress?.pincode || '',
      prop36: order?.lead?.customer?.authorizedSignatory?.companyName || '',
      prop20: order?.companyAddress?.addressLine1 || '',
      // Prop26=<bandwidth>
      // Prop28=<site type>
      prop10: order?.orderId || '',
      // Prop29=<media type>
      // Prop22=<contract period>
      prop18: order?.lead?.planDetail?.totalPrice || '',
      prop1: order?.purchaseOrder?.poNumber || '',
      prop24: order?.documents?.PURCHASE_ORDER?.PO_DOCUMENT || '',
      prop25: order?.purchaseOrder?.purchaseOrderDate || '',
      prop2: order?.purchaseOrder?.poAmount || '',
      prop3: order?.billingType || '',
      prop4: order?.billingCycle || '',
      prop5: order?.lead?.customer?.panNumber || '', //<account number>
      prop16: order?.companyAddress?.city || '',
      // Prop7=<full name of site contact details>
      // Prop8=<mobile number of site contact details>
      // Prop9=<email address of site contact details>
      // Prop37=<customer need by date>
      prop38: order?.fiscalCode?.id || ''
      // Prop11=<full name of CPM>
      // Prop12=<mobile number of CPM>
      // Prop13=<email address of CPM>
    });
  };

  const setDefaultFormData = () => {
    const siteReadiness = order?.lead?.connectivityLineItems?.[0]?.siteReadiness;

    let parsedSiteReadiness = '';
    if (!isNull(siteReadiness)) {
      parsedSiteReadiness = siteReadiness ? 'Yes' : 'No';
    }
    const selectedSiteReadiness = SITE_READINESS_OPTIONS.find((item) => item.id === parsedSiteReadiness) || {};
    setSelectedOption(selectedSiteReadiness);

    if (siteReadiness) {
      setAppointmentData((selectedAppointment) => ({
        ...selectedAppointment,
        appointmentDate: order?.lead?.connectivityLineItems?.[0]?.siteInstallAppointmentDetail?.appointmentDate,
        startTime: order?.lead?.connectivityLineItems?.[0]?.siteInstallAppointmentDetail?.timeInterval?.start,
        endTime: order?.lead?.connectivityLineItems?.[0]?.siteInstallAppointmentDetail?.timeInterval?.finish
      }));
    } else {
      setSiteReadyByDate(defaultSiteReadyByDate || '');
    }
  };

  const checkOrderConfirmationStatusPending = () => {
    const order = getCurrentOrder?.();
    const orderStatus = order?.orderStatus;

    return (orderStatus && [ORDER_TYPE.ORDER_CONFIRMATION, ORDER_TYPE.ORDER_CONFIRMATION_PENDING])?.includes(orderStatus) || isOrderConfirmationUrl();
  };

  const getColumnsFor_Appointment = (item) => {
    const {
      address: { addressLine1, circle },
      customerNeedDate,
      siteReadiness,
      siteReadinessDate
    } = item;

    const appointmentDate = item.siteInstallAppointmentDetail?.appointmentDate;
    const appointmentId = item.siteInstallAppointmentDetail?.appointmentId;
    const start = item.siteInstallAppointmentDetail?.timeInterval?.start;
    const finish = item.siteInstallAppointmentDetail?.timeInterval?.finish;
    const selectedMedia = item?.selectedMedia?.[0]?.media;
    const isThirdPartyMedia = selectedMedia === 'Third Party' || selectedMedia === 'TP';

    return {
      col1: {
        data: addressLine1
      },
      col2: {
        data: moment(new Date(customerNeedDate)).format(DATE_FORMATS.DD_MMM_YYYY) || '-'
      },
      col3: {
        data: siteReadiness ? 'Yes' : 'No',
        subData: !siteReadiness ? (
          <span>
            <i className="aeh-icon-outlined-calendar" /> {(siteReadinessDate && moment(new Date(siteReadinessDate)).format(DATE_FORMATS.DD_MMM_YYYY)) || '-'}
          </span>
        ) : null
      },
      col4: {
        data: (
          <div
            className="value"
            style={{
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            {appointmentDate ? (
              <span>
                <i className="aeh-icon-outlined-calendar" /> {(appointmentDate && moment(appointmentDate).format(DATE_FORMATS.DD_MMM_YYYY)) || '-'}
              </span>
            ) : (
              '-'
            )}
            {start && finish ? (
              <span>
                <i className="aeh-icon-outlined-clock-icon" /> {(start && ampmParser(start)) || '-'} - {(finish && ampmParser(finish)) || '-'}
              </span>
            ) : (
              '-'
            )}
          </div>
        )
      },
      col5: {
        data:
          !siteReadiness || checkOrderConfirmationStatusPending() || isOrderConfirmation || isThirdPartyMedia || !isCircleEligible(circle) ? (
            <span style={{ color: '#666666' }}>{appointmentDate && start && finish ? 'Reschedule Appointment' : 'Schedule Appointment'}</span>
          ) : (
            <a
              href="javascript:void(0);"
              role="button"
              tabIndex="0"
              onClick={() => handleOpenAppointment(item, appointmentDate && start && finish)}
              style={{ color: '#cc000a' }}
              disabled={!siteReadiness}
            >
              {appointmentDate && start && finish ? 'Reschedule Appointment' : 'Schedule Appointment'}
            </a>
          )
      }
    };
  };

  const fetchTableData = async (order_token = null, page, size, filterParams, contentData = [], isFilterApplied = filterApplied) => {
    try {
      setShowLoader(true);

      const orderAuthToken = order_token || getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN);

      const activePage = page || currentPage - 1;
      const activeDataPerPage = size || (dataPerPageValue && dataPerPageValue.key);

      const { res, err } = await fetchOrderDetails(orderAuthToken, activePage, activeDataPerPage, filterParams ? filterParams : {});
      if (res) {
        const { data: { success = false, result = {} } = {} } = res;

        if (success) {
          setShowLoader(false);
          setSlotBooked(false);

          const { totalElement = '', totalPages = '', content = [] } = result;
          setTableData(content);

          const tableColumnsList = [];

          setTotalSitesProcessed(totalElement);
          setTotalPages(totalPages);

          const nearest10digitNumber = totalElement > 10 ? Math.ceil(totalElement / 10) * 10 : totalElement;

          const filteredArr = defaultDataPerPageOptions.filter((item) => item.key <= nearest10digitNumber);

          if (filteredArr.length > 0) {
            setDataPerPageOptions(filteredArr);
          } else {
            setDataPerPageOptions(defaultDataPerPageOptions);
          }

          if (content && content.length > 0) {
            content.forEach((item) => {
              const columns = getColumnsFor_Appointment(item);
              tableColumnsList.push(columns);
            });
          }

          setTableColumns(tableColumnsList);
        }
      } else if (err) {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        setShowLoader(false);
        setToast(true, errorMsg, TOAST_TYPE.ERROR);
        throw new Error(errorMsg);
      }
    } catch (err) {
      const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        setShowLoader(false);
        setToast(true, errorMsg, TOAST_TYPE.ERROR);
        throw new Error(errorMsg);
    }
  };

  const toggelToastPopup = () => {
    setToast(false, '', '');
  };

  const handleEditSubmit = () => {
    fetchTableData();
    setShowEditModal(false);
    toggelToastPopup();

    setAccordionMeta({
      isExpanded: true,
      isValidated: true
    });
  };

  const handleClearFilter = (reload = true) => {
    setFiltersApplied(false);
    setSearchType('');
    setSearchValue('');
    setFilterValue(defaultFilterOptions[0]);

    if (reload) fetchTableData(null, null, null, null, [], false);
  };

  const handleFileUpload = (uploadedFiles, isFileUploaded) => {
    if (isFileUploaded) {
      handleClearFilter(false);
      setInSessionStorage(MULTI_SITE_MODULE_ID, SITE_READINESS_TABLE_EDITED, isFileUploaded);
    }
    setIsEdit(isFileUploaded);
    setEditFileMeta(uploadedFiles[0]);
  };

  const sendAnalytics = () => {
    const order = getCurrentOrder();
    const lead = getCurrentLead();
    trackAnalytics({
      eVar0: `b2b|${order?.serviceType}|buy|confirm installations|site readiness widget|reschedule appointment`,
      prop0: `b2b|${order?.lead?.customer?.segment}|${order?.serviceType}`,
      prop15: order?.customerEmail || '', //email address
      prop17: `${order?.lead?.customer?.authorizedSignatory?.firstName || ''} ${order?.lead?.customer?.authorizedSignatory?.lastName || ''}`, //full name
      prop14: order?.lead?.customer?.authorizedSignatory?.phoneNumber || '', //phone number
      prop35: order?.companyAddress?.officeName || '',
      prop39: order?.lead?.customer?.segment || '',
      prop40: order?.serviceType || '',
      prop37: order?.orderType || '',
      // prop41=<type of site>
      // Prop43=<no. of sites>
      prop21: order?.lead?.connectivityLineItems?.[0]?.feasibilityId || '', //feasibility request id
      // Prop23=<link id>
      prop9: order?.companyAddress?.pincode || '',
      prop36: order?.companyAddress?.officeName || '',
      prop20: order?.companyAddress?.addressLine1 || '',
      prop26: order?.lead?.connectivityLineItems?.[0]?.planDetail?.speed || '',
      // Prop28=<site type>
      prop10: order?.orderId || '',
      prop29: order?.lead?.connectivityLineItems?.[0]?.selectedMedia?.[0]?.media || '',
      prop22: order?.lead?.connectivityLineItems?.[0]?.planDetail?.planPeriod || '',
      prop18: order?.lead?.planDetail?.totalPrice || '',
      prop1: order?.purchaseOrder?.poNumber || '',
      prop24: order?.documents?.PURCHASE_ORDER?.PO_DOCUMENT || '',
      prop25: order?.purchaseOrder?.purchaseOrderDate || '',
      prop2: order?.purchaseOrder?.poAmount || '',
      prop3: order?.billingType || '',
      prop4: order?.billingCycle || '',
      prop5: order?.lead?.customer?.panNumber || '',
      prop16: order?.companyAddress?.city || '',
      prop7: order?.siteIncharge?.firstName || '',
      prop8: order?.siteIncharge?.phoneNumber || '',
      prop9: order?.siteIncharge?.email || '',
      prop37: order?.lead?.connectivityLineItems?.[0]?.customerNeedDate || '',
      prop38: order?.fiscalCode?.id || ''
      // Prop11=<full name of CPM>
      // Prop12=<mobile number of CPM>
      // Prop13=<email address of CPM>
    });
  };

  const editExcelBtnClickHandler = () => {
    setShowEditModal(true);
    const lead = getCurrentLead();
    trackAnalytics({
      eVar9: `b2b|${order?.serviceType}|buy|confirm installations|site readiness widget|edit with excel`,
      prop0: `b2b|${order?.lead?.customer?.segment}|${order?.serviceType}`,
      prop15: order?.customerEmail || '', //email address
      prop17: `${order?.lead?.customer?.authorizedSignatory?.firstName || ''} ${order?.lead?.customer?.authorizedSignatory?.lastName || ''}`, //full name
      prop14: order?.lead?.customer?.authorizedSignatory?.phoneNumber || '', //phone number
      prop35: order?.companyAddress?.officeName || '',
      prop39: order?.lead?.customer?.segment || '',
      prop40: order?.serviceType || '',
      prop37: order?.orderType || '',
      // prop41=<type of site>
      // Prop43=<no. of sites>
      // prop21=<feasibility request id>
      // Prop23=<link id>'
      prop9: order?.companyAddress?.pincode || '',
      prop36: order?.lead?.customer?.authorizedSignatory?.companyName || '',
      prop20: order?.companyAddress?.addressLine1 || '',
      // Prop26=<bandwidth>
      // Prop28=<site type>
      prop10: order?.orderId || '',
      // Prop29=<media type>
      // Prop22=<contract period>
      prop18: order?.lead?.planDetail?.totalPrice || '',
      prop1: order?.purchaseOrder?.poNumber || '',
      prop24: order?.documents?.PURCHASE_ORDER?.PO_DOCUMENT || '',
      prop25: order?.purchaseOrder?.purchaseOrderDate || '',
      prop2: order?.purchaseOrder?.poAmount || '',
      prop3: order?.billingType || '',
      prop4: order?.billingCycle || '',
      prop5: order?.lead?.customer?.panNumber || '', //<account number>
      prop16: order?.companyAddress?.city || '',
      // Prop7=<full name of site contact details>
      // Prop8=<mobile number of site contact details>
      // Prop9=<email address of site contact details>
      // Prop37=<customer need by date>
      prop38: order?.fiscalCode?.id || ''
      // Prop11=<full name of CPM>
      // Prop12=<mobile number of CPM>
      // Prop13=<email address of CPM>
    });
  };

  useEffect(() => {
    setDefaultFormData();

    if (isMultiSite) {
      fetchTableData();
    }
  }, [circleData]);

  useEffect(() => {
    if (slotBooked || isOrderConfirmation) {
      fetchTableData();
    }
  }, [slotBooked, isOrderConfirmation]);

  useEffect(() => {
    if (selectedOption?.id === 'Yes') {
      document.querySelector('.sub_title.warn')?.classList.add('hide');
      document.querySelector('.sub_title.info')?.classList.remove('hide');
    } else if (selectedOption?.id === 'No') {
      document.querySelector('.sub_title.info')?.classList.add('hide');
      document.querySelector('.sub_title.warn')?.classList.remove('hide');
    } else {
      document.querySelector('.sub_title.warn')?.classList.add('hide');
      document.querySelector('.sub_title.info')?.classList.add('hide');
    }

    // accordion handling
    if (selectedOption?.id) {
      setAccordionMeta({
        isExpanded: true,
        isValidated: true
      });
    } else {
      setAccordionMeta({
        isExpanded: true,
        isValidated: false
      });
    }
  }, [selectedOption?.id]);

  useEffect(() => {
    if (tableData?.length > 0) {
      setAccordionMeta({
        isExpanded: true,
        isValidated: true
      });
    } else {
      setAccordionMeta({
        isExpanded: true,
        isValidated: false
      });
    }
  }, [tableData.length]);

  useEffect(() => {
    const selectedKey = dataPerPageValue && dataPerPageValue.key;
    let filterParams = {};

    if (searchType && searchValue) {
      filterParams[searchType['key']] = searchValue;
    }

    if (filterValue && filterValue.displayName !== 'All') {
      filterParams[filterValue['key']] = filterValue.displayName === 'Yes' ? true : false;
    }

    if (multiSortArr.length > 0) {
      multiSortArr.forEach((item, index) => {
        filterParams[`sort[${index}].field`] = item.key;
        filterParams[`sort[${index}].ascending`] = item.value;
      });
    }

    let timeoutId;
    if (filterApplied) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => fetchTableData(null, currentPage - 1, selectedKey, filterParams, []), searchType && searchValue ? CALLBACK_DELAY : 0);
    }

    return () => {
      clearTimeout(timeoutId);
    };
  }, [dataPerPageValue, currentPage, searchType, searchValue, filterValue, multiSortArr, filterApplied]);

  return (
    <Fragment>
      {showEditModal && (
        <DrawerModalComponent
          isOpen={showEditModal}
          setIsOpen={setShowEditModal}
          title="Edit Sites with Excel"
          onSaveClick={handleEditSubmit}
          downloadHeading="Export Applicable Sites"
          downloadSubHeading={
            'Use the button below to download the Excel file and fill in the site readiness details (Pre-Requisite for booking Appointment). Save and upload the file in the section below.'
          }
          downloadBtnName="Download Excel"
          toast={toast}
          setToast={setToast}
          currentPage={FILE_UPLOAD_PAGES.SITE_READINESS}
          onDrawerUploadCb={handleFileUpload}
        />
      )}
      <div className="site_readiness">
        <Accordion
          title={<div>Site Readiness &amp; Appointment Details</div>}
          isExpanded={accordionMeta.isExpanded}
          isValidated={accordionMeta.isValidated}
          autoScrollOnExpand={true}
          variant="round"
        >
          <div className="form_section">
            <div className="info_section">
              <div className="content">
                <div className="content_title">For smooth &amp; fast installation, please ensure:</div>
                <div className="item_title">Server room is ready with:</div>
                <ul className="requirement_details">
                  <li>
                    <i className="aeh-icon-tick"></i> Space &amp; rack for server setup
                  </li>
                  <li>
                    <i className="aeh-icon-tick"></i> Proper Voltage (220V – 240V) with Earthing (0.1V - 2V)
                  </li>
                  <li>
                    <i className="aeh-icon-tick"></i> Uninterrupted power supply (UPS)
                  </li>
                </ul>
                <div className="item_title">Permission available for:</div>
                <ul className="requirement_details">
                  <li>
                    <i className="aeh-icon-tick"></i> Pole or tower Installation with access to rooftop (only for wireless)
                  </li>
                  <li>
                    <i className="aeh-icon-tick"></i> In-building wiring
                  </li>
                </ul>
              </div>
            </div>
            {isMultiSite ? (
              <div className="action_section">
                <div className="action">
                  {!isSiteReadinessTableEdited && !isOrderConfirmation ? (
                    <Button className="btn activebtn" onClick={editExcelBtnClickHandler}>
                      Edit with Excel
                    </Button>
                  ) : (
                    <div
                      className="table-container"
                      style={{
                        marginTop: 16
                      }}
                    >
                      <AddressProcess
                        showProcessComponent
                        showFilterOptions={false}
                        showTableData={isSiteReadinessTableEdited || isOrderConfirmation}
                        showFileName={isEdit}
                        fileData={editFileMeta}
                        showSubHeader={false}
                        showSearchFilterOptions={false}
                        processIdLabel={''}
                        processId={''}
                        processSiteLabel={'Total Sites'}
                        processSiteProcessed={totalSitesProcessed}
                        onProcessBtnClick={editExcelBtnClickHandler}
                        processBtnName={'Edit with Excel'}
                        filterLabel=""
                        filterValue={filterValue}
                        filterOptions={defaultFilterOptions}
                        filterOnChange={(value) => {
                          setFiltersApplied(true);
                          setFilterValue(value);
                        }}
                        searchType={searchType}
                        onSearchTypeChange={(type) => {
                          setFiltersApplied(false);
                          setSearchType(type);
                          setSearchValue('');
                        }}
                        searchValue={searchValue}
                        onSearchValueChange={(value) => {
                          setFiltersApplied(true);
                          setSearchValue(value);
                        }}
                        searchTypeOptions={[]}
                        onSearchClick={() => {
                          let filterParams = {};

                          if (searchType && searchValue) {
                            filterParams[searchType['key']] = searchValue;
                          }
                          fetchTableData(null, null, null, filterParams, []);
                        }}
                        onClearFilter={handleClearFilter}
                        rows={tableRows}
                        cols={tableColumns}
                        dataPerPageValue={dataPerPageValue}
                        dataPerPageOptions={dataPerPageOptions}
                        dataPerPageOnChange={(val) => {
                          setFiltersApplied(true);
                          setDataPerPageValue(val);
                        }}
                        currentPage={currentPage}
                        onPageSelect={(pageNo) => {
                          setFiltersApplied(true);
                          setShowLoader(true);
                          setCurrentPage(pageNo);
                        }}
                        totalPages={totalPages}
                        onSortClick={() => {}}
                        filterApplied={filterApplied}
                        showLoader={showLoader}
                        showEditExcelButtonLoader={isOrderConfirmation}
                        isRowSpanEnabled={false}
                      />
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div className="action_section">
                <div className="title">Is the site ready for installation?</div>
                <div className="content">
                  <RadioGroup options={SITE_READINESS_OPTIONS} value={selectedOption} onChange={handleRadioChange} disabled={checkOrderConfirmationStatusPending()} />

                  {selectedOption?.id === 'Yes' && appointmentData.appointmentDate && appointmentData.startTime && appointmentData.endTime && (
                    <div className="selected_appointment">
                      <div className="info">
                        Appointment is scheduled for{' '}
                        <div className="value">
                          <span>
                            <i className="aeh-icon-outlined-calendar" /> {moment(appointmentData.appointmentDate).format(DATE_FORMATS.DD_MMM_YYYY)}
                          </span>
                          <span>
                            <i className="aeh-icon-outlined-clock-icon" /> {ampmParser(appointmentData.startTime)} - {ampmParser(appointmentData.endTime)}
                          </span>
                        </div>
                      </div>
                      <div className="action">
                        <Button
                          className="outline-btn"
                          onClick={() => {
                            setShowWidget(true);
                            sendAnalytics();
                          }}
                          variant="outlinebtn"
                          disabled={checkOrderConfirmationStatusPending()}
                        >
                          Reschedule Appointment
                        </Button>
                      </div>
                    </div>
                  )}
                  {selectedOption?.id === 'No' && (
                    <Fragment>
                      {defaultSiteReadyByDate && (
                        <div className="selected_appointment">
                          <div className="info">
                            Tentative Site Readiness Date{' '}
                            <div className="value">
                              <span>
                                <i className="aeh-icon-outlined-calendar" /> {moment(defaultSiteReadyByDate).format(DATE_FORMATS.DD_MMM_YYYY)}
                              </span>
                            </div>
                          </div>
                          {/* <div className="action">
                        <Button className="outline-btn" onClick={() => setShowWidget(true)} variant="outlinebtn" disabled={checkOrderConfirmationStatusPending()}>
                          Change Date
                        </Button>
                      </div> */}
                        </div>
                      )}
                      <div className="customer-need-by-date-section">
                        <h4 className="heading">Tentative Site Readiness Date</h4>
                        <Datepicker
                          name="datepicker"
                          label="Tentative site readiness date"
                          required={true}
                          errors={[]}
                          touched={false}
                          value={siteReadyByDate}
                          onChange={(value) => setSiteReadyByDate(value)}
                          maxDate={new Date(new Date().setYear(new Date().getFullYear() + 5))}
                          minDate={new Date()}
                          years={getRange(new Date().getFullYear(), new Date().getFullYear() + 5)}
                          disabled={checkOrderConfirmationStatusPending()}
                        />
                        {/* <div className="error-msg">{error}</div> */}
                      </div>
                    </Fragment>
                  )}
                  {Object.keys(selectedOption).length > 0 && (
                    <div className="customer-need-by-date-section">
                      <h4 className="heading">Customer Need by Date</h4>
                      <Datepicker
                        name="datepicker"
                        label="Customer Need by Date"
                        required={true}
                        errors={[]}
                        touched={false}
                        value={customerNeedByDate}
                        onChange={(value) => setCustomerNeedByDate(value)}
                        maxDate={new Date(new Date().setYear(new Date().getFullYear() + 5))}
                        // minDate={new Date()}
                        minDate={getCurrentOrder?.()?.estimatedDate ? new Date(getCurrentOrder?.()?.estimatedDate) : new Date()}
                        years={getRange(new Date().getFullYear(), new Date().getFullYear() + 5)}
                        disabled={checkOrderConfirmationStatusPending()}
                      />
                      <div className="error-msg">{error}</div>
                      {/* <div className="button_group">
                          <Button disabled={isNull(siteReadyByDate) || isNull(customerNeedByDate) } onClick={handleSubmit}>
                            Confirm{' '}
                          </Button>
                        </div> */}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </Accordion>
      </div>
    </Fragment>
  );
};

export default SiteReadinessAccordion;
